import { Empty } from '../empty';

/**
 * A multipart component for indicating a region has an error. Composes `Box`.
 */
export const Error = Empty;
Error.displayName = 'Error';
